import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from "antd/lib/card";
import MineInput from "./MineInput.js";
import MineButton from "./MineButton.js";
import "./MineCard.css";

class MineCard extends Component {
  state = {
    newBlockData: ""
  }

  changeData = (e) => {
    this.setState({
      newBlockData: e.target.value
    })
  }

  render() {
    return (
      <Card 
        className="mine is-valid mine-shadow"
      >
        <div className="items">
          <MineInput
            changeData={this.changeData}
          />
          <MineButton
            newBlockData={this.state.newBlockData}
            peer={this.props.peer}
            latestBlock={this.props.latestBlock}
          />
        </div>
      </Card>
    );
  }
}

MineCard.propTypes = {
  peer: PropTypes.string,
  latestBlock: PropTypes.object
};

export default MineCard;


// WEBPACK FOOTER //
// ./src/Mine/MineCard.js